"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _validation = require("../validation");

var _collections = require("../collections");

var _tnUtils = require("@thinknimble/tn-utils");

var _fields = require("./fields");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Model = /*#__PURE__*/function () {
  function Model() {
    var kwargs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Model);

    // Collect the fields defined as static properties into
    // a private `_fields` object.
    this._fields = this.constructor.getFields(); // Loop over fields and assign kwarg values to this instance

    for (var fieldName in this._fields) {
      var field = this._fields[fieldName];
      this[fieldName] = field.clean(kwargs[fieldName]);
    }
  } // Gather `static` fields


  _createClass(Model, null, [{
    key: "getFields",
    value: function getFields() {
      var fields = {};

      for (var prop in this) {
        if (this[prop] instanceof _fields.Field) {
          fields[prop] = this[prop];
        }
      }

      return fields;
    } // Gather read-only fields

  }, {
    key: "getReadOnlyFields",
    value: function getReadOnlyFields() {
      //
      var legacyReadOnlyFields = this.readOnlyFields ? this.readOnlyFields : []; //

      var readOnlyFields = [];

      for (var _i = 0, _Object$entries = Object.entries(this.getFields()); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (value.readOnly === true) {
          readOnlyFields.push(key);
        }
      }

      return [].concat(_toConsumableArray(legacyReadOnlyFields), readOnlyFields);
    }
    /**
     * Static Factory Methods
     *
     * Because these are `static`, `this === SubClass`, which means
     * that `new this()` will invoke the constructor of the subclass,
     * giving us a new instance of type `SubClass`!
     */

  }, {
    key: "create",
    value: function create() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new this(opts);
    }
  }, {
    key: "fromAPI",
    value: function fromAPI() {
      var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new this((0, _tnUtils.objectToCamelCase)(json));
    }
    /**
     * To API Method
     *
     * Convert an instance of this class to a plain old JavaScript object
     * suitable for JSON serialization and submitting to the API.
     */

  }, {
    key: "toAPI",
    value: function toAPI(obj) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var excludeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      // By default, send the whole object
      var data = {}; // If it's a partial update, get only the fields specified

      if (fields.length > 0) {
        fields.forEach(function (field) {
          data[field] = obj[field];
        });
      } else {
        data = _objectSpread({}, obj);
      } // Delete private '_fields' member


      delete data['_fields']; // Remove read only and excluded fields

      [].concat(_toConsumableArray(this.getReadOnlyFields()), _toConsumableArray(excludeFields)).forEach(function (item) {
        delete data[item];
      });
      return (0, _tnUtils.objectToSnakeCase)(data);
    }
    /**
     * Create a Collection for current ModelClass.
     * @param {Object} opts collection options, such as filters.
     * @returns {CollectionManager}
     */

  }, {
    key: "createCollection",
    value: function createCollection(opts) {
      return _collections.CollectionManager.create(_objectSpread({}, opts, {
        ModelClass: this.constructor
      }));
    }
  }]);

  return Model;
}();

exports["default"] = Model;